import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { VehiclesDetailPageRoutingModule } from './vehicles-detail-routing.module';

import { VehiclesDetailPage } from './vehicles-detail.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, VehiclesDetailPageRoutingModule],
  declarations: [VehiclesDetailPage]
})
export class VehiclesDetailPageModule {}
